(function () {
  if (window.__atcButtonInitialized) return;
  window.__atcButtonInitialized = true;

  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-atc-variant]');
    if (!btn) return;

    var variantId = parseInt(btn.dataset.atcVariant, 10);
    if (!variantId) return;

    e.preventDefault();

    var originalHTML = btn.innerHTML;
    btn.disabled = true;
    btn.innerHTML = '<span>Adding…</span>';

    var cartBody = { id: variantId, quantity: 1 };
    var sellingPlanId = parseInt(btn.dataset.atcSellingPlan, 10);
    if (sellingPlanId) cartBody.selling_plan = sellingPlanId;

    fetch(window.routes && window.routes.cart_add_url ? window.routes.cart_add_url : '/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify(cartBody)
    })
      .then(function (res) {
        if (!res.ok) return res.json().then(function (d) { var err = new Error(d.description || 'Could not add item to cart.'); err.httpStatus = res.status; throw err; });
        return res.json();
      })
      .then(function () {
        if (window.posthog) {
          posthog.capture('add_to_cart', {
            variant_id: String(variantId),
            quantity: 1,
            purchase_type: sellingPlanId ? 'subscription' : 'one_time',
            selling_plan_id: sellingPlanId ? String(sellingPlanId) : null,
          });
        }
        var cartDrawer = document.querySelector('cart-form');
        if (cartDrawer && typeof cartDrawer.getCartData === 'function') {
          cartDrawer.getCartData('open_drawer');
        }
      })
      .catch(function (err) {
        if (window.notificationEle && typeof window.notificationEle.updateNotification === 'function') {
          window.notificationEle.updateNotification('Cart', err.message, { type: 'error', timeout: 3000 });
        }
        if (window.bubsTrackCartError) {
          window.bubsTrackCartError({
            http_status: err.httpStatus || 0,
            error_message: err.message || null,
            variant_id: variantId,
            quantity: 1,
            purchase_type: sellingPlanId ? 'subscription' : 'one_time',
            selling_plan_id: sellingPlanId || null,
            source: 'atc_button',
          });
        }
      })
      .finally(function () {
        btn.disabled = false;
        btn.innerHTML = originalHTML;
      });
  });
})();
